'use strict';

module.exports = function (a, b) {
  return require('./altErgo').runAltErgo(JSON.stringify(a), JSON.stringify(b))
};
